export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const API_FOLDER = process.env.REACT_APP_API_FOLDER;
